import { useSelection } from "@frend-digital/centra/client";

export const useCart = () => {
  return useSelection({
    select: data => {
      return {
        totals: data?.selection?.totals,
        total: data?.selection?.totals?.grandTotalPrice,
        totalPriceAsNumber: data?.selection?.totals?.grandTotalPriceAsNumber,
        itemsTotalPriceAsNumber:
          data?.selection?.totals?.itemsTotalPriceAsNumber,
        itemsTotalPrice: data?.selection?.totals?.itemsTotalPrice,
        items: data?.selection?.items,
        itemCount: data?.selection?.items?.length,
        vouchers: data?.selection?.discounts?.vouchers,
        promoCodes: data?.selection?.discounts,
        shippingPrice: data?.selection?.totals?.shippingPrice,
        shippingPriceAsNumber: data?.selection?.totals?.shippingPriceAsNumber,
        currency: data?.selection?.currency,
      };
    },
  });
};
